import {useField} from "react-final-form";
import React from "react";

type EqualityFn<T> = (a: T, b: T) => boolean;

export interface OnBlurValueChangeProps<T> {
    name: string;
    onChange: (value: T, previous: T) => void;
    equals?: EqualityFn<T>; // volitelné: vlastní porovnání
}

export function OnBlurValueChange<T = string>({
                                           name,
                                           onChange,
                                           equals = Object.is,
                                       }: OnBlurValueChangeProps<T>) {
    const {
        input: { value },
        meta: { active },
    } = useField<T>(name, { subscription: { value: true, active: true } });

    const wasActiveRef = React.useRef<boolean|undefined>(active);
    const lastCommittedRef = React.useRef<T>(value);

    React.useEffect(() => {
        const wasActive = wasActiveRef.current;

        // blur detekce: active true -> false
        if (wasActive && !active) {
            if (!equals(lastCommittedRef.current, value)) {
                onChange(value, lastCommittedRef.current);
                lastCommittedRef.current = value;
            }
        }
        wasActiveRef.current = active;
    }, [active, value, onChange, equals]);

    return null;
}